import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import { ApprovalRules } from '../types';
import { ApprovalRulesRadioAnyHelpText } from './i18n/ApprovalRulesRadioI18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalRulesRadio = props => {
  const {
    approvalType,
    onChangeApprovalRule
  } = props;
  const onChange = evt => {
    onChangeApprovalRule(evt.target.value);
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalRules.radioHeading"
    }),
    required: true,
    children: /*#__PURE__*/_jsxs(UIToggleGroup, {
      name: "productApprovalsApprovalRules",
      children: [/*#__PURE__*/_jsx(UIRadioInput, {
        "data-test-id": "approval-rules-non-sequential",
        defaultChecked: true,
        value: ApprovalRules.NON_SEQUENTIAL,
        onChange: onChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRules.radioAll"
        })
      }), /*#__PURE__*/_jsxs(UIRadioInput, {
        "data-test-id": "approval-rules-any-can-approve",
        value: ApprovalRules.ANY_CAN_APPROVE,
        onChange: onChange,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRules.radioAny.main"
        }), /*#__PURE__*/_jsx(Small, {
          className: "display-block",
          use: "help",
          children: /*#__PURE__*/_jsx(ApprovalRulesRadioAnyHelpText, {
            approvalType: approvalType
          })
        })]
      })]
    })
  });
};
export default ApprovalRulesRadio;